/* unplugin-vue-components disabled */import script from "./AccountInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountInfo.vue?vue&type=script&setup=true&lang=js"

import "./AccountInfo.vue?vue&type=style&index=0&id=b9350e4e&lang=scss"

const __exports__ = script;

export default __exports__